import { Component, OnInit } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { LinkAboutBgtViewerComponent } from "../shared/link-about-bgt-viewer/link-about-bgt-viewer.component";
import { LinkDownloadBgtComponent } from "../shared/link-download-bgt/link-download-bgt.component";
import { LinkAboutBgtComponent } from "../shared/link-about-bgt/link-about-bgt.component";
import { CallToActionComponent } from "../shared/call-to-action/call-to-action.component";

@Component({
    selector: "app-wms-wfs",
    templateUrl: "./wms-wfs.component.html",
    styleUrls: ["./wms-wfs.component.scss"],
    imports: [MatIcon, LinkAboutBgtViewerComponent, LinkDownloadBgtComponent, LinkAboutBgtComponent, CallToActionComponent]
})
export class WmsWfsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: "smooth" });
  }
}
